module.exports = __webpack_public_path__ + "img/bhutan.e3280f71.svg";